/* eslint-disable max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { observable, action, reaction } from 'mobx'
import { getFromApi } from '../services/apiService'
import { IProposedBookings, IFullVehicleModel } from './bookingTypes'
import moment from 'moment'
import { IStores } from '.'
import { sendBookingAnalyticEvent } from '../services/analyticsService'
import { computeDuration } from '../utils/formattersHelper'
import { formatDuration } from '../utils/scheduleDurationHelper'
import i18n from '../utils/config/i18n'

const API_DATE_FORMAT = 'YYYY-MM-DDTHH:mm'
const build_BOOKINGPROPOSITIONS_URL = (productReference: string, locationReference: string, startAt: string, endAt: string) => `/v5/reserve/bookings/${productReference}/${locationReference}/${startAt}/${endAt}`

interface ISelectionReaction {
  productReference?: string
  locationReference?: string
  startAt?: string
  endAt?: string
}

class CarsStore {
  store: IStores

  @observable loading = false;

  @observable proposedBookings: IProposedBookings | null = null;
  @observable selectedCarModel: IFullVehicleModel | null = null;

  lastReactionIdentifier = 0

  @action initialise = async (): Promise<void> => {
    this.loading = true

    this.loading = false
  };

  selectionUpdated = action(async (data: ISelectionReaction) => {
    const myReactionIdentifier = moment().valueOf()
    this.lastReactionIdentifier = myReactionIdentifier
    this.loading = true

    if (data.productReference && data.locationReference && data.startAt && data.endAt && moment(data.startAt).isBefore(data.endAt)) {
      const filters = { partnerCode: this.store.registerStore.partnerCode ? this.store.registerStore.partnerCode : undefined }
      const response = await getFromApi(build_BOOKINGPROPOSITIONS_URL(data.productReference, data.locationReference, data.startAt, data.endAt), filters)

      if (myReactionIdentifier !== this.lastReactionIdentifier) {
        console.debug('CarStore.reaction - cancel proposition for ', data.productReference, data.locationReference, data.startAt, data.endAt)

        return
      }
      this.proposedBookings = response && response.status === 200 ? response.data : null
      sendBookingAnalyticEvent('view_items_list', this.store.locationsStore.selectedCity, this.store.locationsStore.selectedLocation, this.proposedBookings?.bookings)
    }
    this.loading = false
  });

  constructor(store: IStores) {
    this.store = store

    reaction(
      () => {
        return {
          productReference: this.store.productsStore.selectedProduct?.reference,
          locationReference: this.store.locationsStore.selectedLocation?.reference,
          startAt: this.store.calendarStore.selectedStartAt?.format(API_DATE_FORMAT),
          endAt: this.store.calendarStore.selectedEndAt?.format(API_DATE_FORMAT)
        }
      },
      (data: ISelectionReaction) => {
        console.debug('CarStore.reaction - update proposition for ', data.locationReference, data.startAt, data.endAt)
        const payload = {
          ...data,
          durationUnit: this.store.productsStore.selectedProduct?.durationUnit || 0,
          timezone: this.store.locationsStore.selectedLocation?.timezone,
          minimumDurationUnit: this.store.productsStore.selectedProduct?.minimumDurationUnit,
          maximumDurationUnit: this.store.productsStore.selectedProduct?.maximumDurationUnit
        }

        const {
          startAt, endAt, timezone, durationUnit, minimumDurationUnit, maximumDurationUnit
        } = payload

        const duration = computeDuration(moment(startAt), moment(endAt), durationUnit, timezone)

        const errorMessages = () => {
          if (minimumDurationUnit && duration < minimumDurationUnit) {
            this.proposedBookings = null

            return `${i18n.t('reserve:minDurationMustBeAlertLabel')}: ${formatDuration(minimumDurationUnit, durationUnit)}`
          }

          if (maximumDurationUnit && duration > maximumDurationUnit) {
            this.proposedBookings = null

            return `${i18n.t('reserve:maxDurationMustBeAlertLabel ')}: ${formatDuration(maximumDurationUnit, durationUnit)}`
          }

          return null
        }

        const _errorMessage = errorMessages()

        this.store.calendarStore.setValidationErrorMessage(_errorMessage)

        if (!_errorMessage) {
          this.selectionUpdated(data)
        }
      },
      { fireImmediately: false }
    )
  }
}

export default CarsStore
